import { render, staticRenderFns } from "./MastersTab.vue?vue&type=template&id=348338f4&scoped=true"
import script from "./MastersTab.vue?vue&type=script&lang=ts"
export * from "./MastersTab.vue?vue&type=script&lang=ts"
import style0 from "./MastersTab.vue?vue&type=style&index=0&id=348338f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348338f4",
  null
  
)

export default component.exports